/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260115
*/
'use strict';

import {
    getPropNmAndKey
} from './ctssArrayUtils.js';
import {
    getTableRows
} from './ctssHtml.js';

import {
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    getAM_PM_DDL_Async,
    getHoursDDL_Async
} from './ctssTimeSpans.js'
import {
    enableBtn,
    isDataModified,
    setModified
} from './ctssVal.js';
import {
    appDebugMode,
    getAppToken,
    setMenu
} from './snSite.js';

const token = getAppToken();

const drawConnectItemRow = (params) => {
    return '<tr><td colspan="7" class="col-md-12 connectItemHdr">' +
        '<input id="cbConnectItem_' + params.connectCardID +
        '" type="checkbox" class="k-checkbox" ' +
        'onclick="snCCardResponses.toggleConnectItem(this.id);" > ' +
        '<label for="cbConnectItem_' + params.connectCardID + '" class="k-checkbox-label"></label>' +
        '<span class="mLeft10">' + params.actionItem +
        '</span><span class="pull-right">' + params.responsePcnt +
        '%</span></td></tr>';
}
const drawParentRow = (params) =>
    '<tr><td colspan="7"class="col-md-12 parentHdr">' + params.parentText + '</td></tr>';

const drawResponseRow = (params) => {
    const dtReq = new Date(params.response.dateRequested);
    const sDtReq = dtReq.getUTCMonth() + 1 + '/' + dtReq.getUTCDate() + '/' + dtReq.getUTCFullYear();
    let sDtCompleted;
    if (params.response.dateCompleted.length === 0) {
        sDtCompleted = '';
    } else {
        const dt = new Date(params.response.dateCompleted);
        sDtCompleted = dt.getUTCMonth() + 1 + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear();
    }

    let row = '<tr><td class="col-md-2">' +
        '<input id="cb_' + params.response.id + '" type="checkbox" class="k-checkbox" ' +
        'onclick="snCCardResponses.enableCompletionBtns();" > ' +
        '<label for="cb_' + params.response.id + '" class="k-checkbox-label"></label>' +
        '<span class="mLeft10">' + params.response.firstName + ' ' + params.response.lastName +
        '</span></td><td class="col-md-3">' + params.response.email +
        '</td><td class="col-md-2">' + params.response.phone +
        '</td><td class="col-md-2">' + params.response.other +
        '</td><td class="col-md-1">' + sDtReq +
        '</td><td class="col-md-1">' + sDtCompleted +
        '</td><td class="col-md-1">' + params.response.daysWaiting +
        '</td></tr>';
    return row;
}
const drawResponseRows = () => {
    let content = '';
    const cnt = connectEvents.length;

    if ($('#ddlFilter').children('option').length === 0) {
        content += drawParentRow({ parentText: 'Connection card has not been built...' });
    }
    else if (cnt > 0) {
        let idx = 0;
        let parentID = -1;
        while (idx < cnt) {

            content += drawParentRow({ parentText: connectEvents[idx].parentText });
            parentID = connectEvents[idx].parentID;

            let connectCardID = -1;
            while (idx < cnt) {
                if (connectCardID !== connectEvents[idx].connectCardID) {
                    content += drawConnectItemRow({
                        connectCardID: connectEvents[idx].connectCardID,
                        actionItem: connectEvents[idx].actionItem,
                        responsePcnt: connectEvents[idx].responsePcnt
                    });
                    connectCardID = connectEvents[idx].connectCardID;
                }
                content += drawResponseRow({ response: connectEvents[idx] });
                idx++;
                if (idx < cnt && parentID !== connectEvents[idx].parentID) {
                    break;
                }
            }
        }
    } else {
        const contentMsg = $('#ddlContent').val() === '2'
            ? ''
            : $('#ddlContent option:selected').html();

        const filterMsg = $('#ddlFilter').val() === '0'
            ? ''
            : ' ' + $('#ddlFilter option:selected').html();

        const asOfTerm = $('#ddlAsOf').val() === '5'
            ? ''
            : ' for the ' + $('#ddlAsOf option:selected').html();

        const asOfMsg = ` event requests have been entered${asOfTerm}...`;

        const dataMsg = ' No ' + contentMsg + filterMsg + asOfMsg;

        content += drawParentRow({ parentText: dataMsg });
    }
    $('#gridResponses tbody').empty().append(content);
    document.getElementById("loader").style.display = "none";
}

const getConnectEventsAsync = async () => {
    const parentID = $('#ddlFilter').val() ?? '0';
    const status = $('#ddlContent').val();
    const asOf = $('#ddlAsOf').val();

    return await getPromise({ url: `CCardResponses/${token.CG}/${parentID}/${status}/${asOf}` });
}

const getParentConnectItemsAsync = async () =>
    await getPromise({ url: `CCards/${token.CG}/ParentCCardItems` });

const hasCheckedItems = () => $('input[id^="cb_"]:checked').length > 0; 


const refreshConnectEventsAsync = async () => {
    try {
        connectEvents = await getConnectEventsAsync();
        drawResponseRows();
        enableCompletionBtns();
    }
    catch (error) { }
}

const updateCompletionDateAsync = async (dtCompleted) => {

    const btnId = (dtCompleted.length === 0)
        ? 'btnClearCompleted'
        : 'btnMarkCompleted';

    let updatedEventRequests = [];
    $('input[id^="cb_"]:checked').each(function () {
        const id = getPropNmAndKey(this.id).key;
        const idx = connectEvents.findIndex(x => x.id === id);
        connectEvents[idx].dateCompleted = dtCompleted;
        updatedEventRequests.push({
            memberID: connectEvents[idx].memberID,
            connectCardID: connectEvents[idx].connectCardID,
            dateCompleted: dtCompleted
        });
    });

    if (updatedEventRequests.length > 0) {
        document.getElementById("loader").style.display = "block";
        await savePromise({
            url: '`CCardResponses/EventCompleted',
            data: {
                cg: token.CG,
                connectEventCompleteStatuses: updatedEventRequests
            }
        })
            .then(async () => {
                await refreshConnectEventsAsync();
                document.getElementById("loader").style.display = "none";
            });
    }
}

let connectEvents = [];

const enableCompletionBtns = () => {
    const enable = hasCheckedItems();
    enableBtn({ btnNm: '#btnMarkCompleted', isEnabled: enable });
    if ($('#ddlContent').val() !== '0') {
        enableBtn({ btnNm: '#btnClearCompleted', isEnabled: enable });
    }
};

const initAsync = async () => {

    setMenu();

    try {
        const data = getParentConnectItemsAsync();

        const ddlFilter = $('#ddlFilter')
        ddlFilter.append($('<option>', { value: '0' }).text('All Connection Items'));
        data.forEach(
            (x) => ddlFilter.append($('<option>', { value: x.value }).text(x.text)));
        ddlFilter.val('0');

        await refreshConnectEventsAsync();
    }
    catch (error) { }

    $('#ddlContent,#ddlFilter,#ddlAsOf').on('change', async () => {
        document.getElementById("loader").style.display = "block";
        await refreshConnectEventsAsync();
    });

    $('#ddlContent').on('change', () => {
        $('#ddlContent').val() === '0'
            ? $('#lblAsOf,#ddlAsOf,#btnClearCompleted').addClass('hidden')
            : $('#lblAsOf,#ddlAsOf,#btnClearCompleted').removeClass('hidden');
    });

    $('#btnSetCompletionDate').on('click', async () => {
        const dtCtrl = $('#editCompletionDate');
        dtCtrl.blur();
        if (dtCtrl[0].value.length > 0) {
            const dt = new Date(dtCtrl[0].value);
            const sDt = dt.getUTCMonth() + 1 + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear();
            await updateCompletionDateAsync(sDt);
        }
        $('#dateDlg').modal('hide');
    });

    $('#btnClear').on('click', async () => {
        await updateCompletionDateAsync('');
        $('#clearDlg').modal('hide');
    });

    $('#dateDlg').on('show.bs.modal', () => {
        $('#editCompletionDate').val(new Date().toISOString().split("T")[0]);
    });

};

const toggleConnectItem = (cbConnectItemID) => {
    const isChecked = $('#' + cbConnectItemID).is(':checked');
    const connectCardID = getPropNmAndKey(cbConnectItemID).key;
    connectEvents.forEach((x) => {
        if (x.connectCardID === connectCardID) {
            $(`#cb_${x.id}`).prop('checked', isChecked);
        }
    });
    enableCompletionBtns();
};

window.snCCardResponses = {
    enableCompletionBtns,
    initAsync,
    toggleConnectItem
};